import { render, staticRenderFns } from "./Type9c.vue?vue&type=template&id=8d6b21fc&"
import script from "./Type9c.vue?vue&type=script&lang=js&"
export * from "./Type9c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports